export enum EstimateMeasurementViewTypes {
    Default = 'default',
    OverLayer = 'overLayer',
}
